import Brett from "./Brett";
import {v3} from "oc-threejs/short3";

export default class Sockel extends Brett {

    // persistent (UserLayer) ------------------------------------------

    // transient (CompiledLayer) ---------------------------------------

    constructor(schrank) {
        super(schrank, 'Sockel', 'xy');
    }

    compile() {
        const outer = this.schrank.corpusBox;
        const inner = this.schrank.elementsBox;
        const xBox = APP.settings.getBool('aussenwand_durchgehend_unten') ? inner : outer;

        const sockelFront = inner.max.z - APP.settings.getMinValue('sockel_ruecksprung_vorn');
        this.box = new THREE.Box3(
            v3(xBox.min.x, outer.min.y, sockelFront - APP.settings.getFloat('brett_staerke')),
            v3(xBox.max.x, outer.min.y + APP.settings.getMinValue('sockel_dicke'), sockelFront)
        );
        this.boxToVertices();
        super.compile();
    }

}